import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
const FADE_PX = 24;
const buildMaskImage = (atStart: boolean, atEnd: boolean) => `linear-gradient(to right, ${atStart ? '#000' : 'transparent'} 0, #000 ${FADE_PX}px, #000 calc(100% - ${FADE_PX}px), ${atEnd ? '#000' : 'transparent'} 100%)`;

// Horizontal-scroll affordances for a row of items: wheel-to-horizontal
// scrolling (browsers don't map a vertical wheel delta onto a horizontal-only
// scroller) and an edge fade marking the side that still hides items. Pass the
// item count so the listeners re-attach as the row mounts and changes.
export const useHorizontalScrollFade = itemCount => {
  const $ = _c(12);
  const ref = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      atStart: true,
      atEnd: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [t1, setEdges] = useState(t0);
  const {
    atStart,
    atEnd
  } = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const el = ref.current;
      if (!el) {
        return;
      }
      const onWheel = e => {
        if (!e.deltaY || el.scrollWidth <= el.clientWidth) {
          return;
        }
        const reachedStart = e.deltaY < 0 && el.scrollLeft <= 0;
        const reachedEnd = e.deltaY > 0 && el.scrollLeft >= el.scrollWidth - el.clientWidth - 1;
        if (reachedStart || reachedEnd) {
          return;
        }
        el.scrollLeft = el.scrollLeft + e.deltaY;
        e.preventDefault();
      };
      const syncEdges = () => {
        const max = el.scrollWidth - el.clientWidth;
        setEdges({
          atStart: el.scrollLeft <= 1,
          atEnd: el.scrollLeft >= max - 1
        });
      };
      syncEdges();
      el.addEventListener("wheel", onWheel, {
        passive: false
      });
      el.addEventListener("scroll", syncEdges, {
        passive: true
      });
      const observer = new ResizeObserver(syncEdges);
      observer.observe(el);
      return () => {
        el.removeEventListener("wheel", onWheel);
        el.removeEventListener("scroll", syncEdges);
        observer.disconnect();
      };
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== itemCount) {
    t3 = [itemCount];
    $[2] = itemCount;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = direction => {
      const el_0 = ref.current;
      if (!el_0) {
        return;
      }
      el_0.scrollBy({
        left: (direction === "forward" ? 1 : -1) * el_0.clientWidth * 0.8,
        behavior: "smooth"
      });
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const scrollByPage = t4;
  let t5;
  if ($[5] !== atEnd || $[6] !== atStart) {
    t5 = buildMaskImage(atStart, atEnd);
    $[5] = atEnd;
    $[6] = atStart;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = !atStart;
  const t7 = !atEnd;
  let t8;
  if ($[8] !== t5 || $[9] !== t6 || $[10] !== t7) {
    t8 = {
      ref,
      maskImage: t5,
      canScrollBack: t6,
      canScrollForward: t7,
      scrollByPage
    };
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};